import React from 'react';
import { UiFlex, UiGrid } from '@open-stack/ui';
import { useCurrency } from '../../../hooks/currency';
import styled from 'styled-components';
import { XCard } from '../../x/card/XCard';
import { XText } from '../../x/text/XText';

const Wrapper = styled(XCard)`
    .progress-container {
        height: 8px;
        width: 100%;
        background-color: var(--x-color-divider);
        border-radius: 8px;
        position: relative;
        margin: 8px 0;

        .progress-bar {
            height: 8px;
            border-radius: 8px;
            max-width: 100%;
            background-color: var(--x-color-success);
            transition: width 300ms;
        }
    }

    .remaining b {
        color: white;
        font-weight: bold;
    }
`;

type Props = {
    amountTotal: number;
    amountPaid: number;
    children?: any;
};

export function OrderPaymentProgressBar({ amountTotal = 0, amountPaid = 0, children }: Props) {
    const { format } = useCurrency();
    const progress = amountPaid >= amountTotal ? 100 : Math.round((amountPaid * 100) / amountTotal);
    const amountToPay = progress === 100 ? 0 : amountTotal - amountPaid;

    return (
        <Wrapper padding={2}>
            <UiGrid>
                <UiGrid gap={0}>
                    <UiFlex justifyContent="space-between">
                        <UiFlex gap={1}>
                            <XText color="text-secondary">Paid</XText>
                            <XText weight={3}>{format(amountPaid)}</XText>
                        </UiFlex>

                        <UiFlex gap={1}>
                            <XText color="text-secondary">Total</XText>
                            <XText weight={3}>{format(amountTotal)}</XText>
                        </UiFlex>
                    </UiFlex>

                    <div className="progress-container">
                        <div style={{ width: `${progress}%` }} className="progress-bar" />
                    </div>

                    <XText color="text-secondary" align="center" className="remaining">
                        Remaining <b>{format(amountToPay)}</b>
                    </XText>
                </UiGrid>

                {children}
            </UiGrid>
        </Wrapper>
    );
}
